import type { DrcSeverity } from "@models/circuit-ir";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import InfoIcon from "@mui/icons-material/InfoOutlineRounded";
import WarningIcon from "@mui/icons-material/ReportProblemOutlined";

interface Props {
  severity: DrcSeverity;
  fontSize?: "small" | "medium" | "large" | "inherit";
}

export function DrcSeverityIcon({ severity, fontSize = "small" }: Props) {
  if (severity === "error")
    return <ErrorIcon color="error" fontSize={fontSize} />;
  if (severity === "warning")
    return <WarningIcon color="warning" fontSize={fontSize} />;
  return <InfoIcon color="info" fontSize={fontSize} />;
}

export const SEVERITY_LABEL: Record<DrcSeverity, string> = {
  error: "Errors",
  warning: "Warnings",
  info: "Info",
};
